import * as React from "react"

import { cn } from "@/lib/utils"

// Apple HIG field: 44px touch height, 12px corners, quiet grey fill, neutral focus.
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-xl border border-[rgba(60,60,67,0.14)] bg-[#FAFAFC] px-3.5 py-2 text-base transition-[border-color,box-shadow,background-color] focus-visible:bg-white file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
